import { popEmeraldModal } from '../../common/emerald-modal-manager/emerald-modal-manager';
import {
  ItemCategory,
  RemoveRejectedItemsWithCategoriesModalId,
  showRemoveRejectedItemsWithCategoriesModal,
} from '../components/remove-items/remove-items-categories-modal';
import {
  RemoveRejectedItemsModalId,
  showRemoveRejectedItemsModal,
} from '../components/remove-items/remove-items-modal';

export const displayRemoveRejectedItemsModal = async (
  itemDescriptions: string[],
): Promise<void> => {
  await new Promise<void>(resolve => {
    if (itemDescriptions.length === 0) {
      resolve();
    } else {
      showRemoveRejectedItemsModal({
        itemDescriptions,
        onClose: resolve,
      });
    }
  });
  popEmeraldModal(RemoveRejectedItemsModalId);
};

export const displayRemoveRejectedItemsWithCategoriesModal = async (
  itemCategories: ItemCategory[],
): Promise<void> => {
  await new Promise<void>(resolve => {
    if (itemCategories.length === 0) {
      resolve();
    } else {
      showRemoveRejectedItemsWithCategoriesModal({
        itemCategories,
        onClose: resolve,
      });
    }
  });

  popEmeraldModal(RemoveRejectedItemsWithCategoriesModalId);
};
